import PropTypes from 'prop-types'
import React from 'react'
import './MessageText.less'

const classNames = require('classnames')

const MessageText = ({children, isSuccess, placeholder, warning, small}) => {
  let classes = classNames('nmc-message-text', {
    'nmc-message-text-small': small,
    'nmc-message-text-success': isSuccess && !placeholder,
    'nmc-message-text-error': !isSuccess && !placeholder,
    'nmc-message-text-warning': !isSuccess && warning
  })

  const spacer = <span className='nmc-message-text-spacer'>&nbsp;</span>

  return (
    <div className={classes}>
      {children || spacer}
    </div>
  )
}

MessageText.propTypes = {
  isSuccess: PropTypes.bool,
  warning: PropTypes.bool,
  placeholder: PropTypes.bool,
  small: PropTypes.bool
}

MessageText.defaultProps = {
  isSuccess: true,
  placeholder: false,
  small: false
}

export default MessageText



// WEBPACK FOOTER //
// ../~/@master/webinfra-frontend-components/src/components/MessageText/index.js